import React, { ReactElement, ReactNode, useState } from 'react';
import LeftMenu from './LeftMenu';
import RightMenu from './RightMenu';
import { Drawer, Button, Grid } from 'antd';
import logo from '../../../assets/logo.png';
import logoMobile from '../../../assets/logo-mobile2.png';
import './Navbar.styles.css';
const { useBreakpoint } = Grid;

const defaultProps = {
	heading: <h2>Heldslo</h2>
};

type NavBarProps = {} & typeof defaultProps;

export const NavBar = ({ heading }: NavBarProps): ReactElement => {
	const [toggle, setToggle] = useState<boolean>(false);
	const { md } = useBreakpoint();
	return (
		<nav className='menuBar'>
			<div className='container menuBar-wrapper '>
				<div className='logo'>
					{!md ? (
						<img src={logoMobile} alt='Logo image' height={60} />
					) : (
						<img src={logoMobile} alt='Logo image' height={70} />
					)}
				</div>
				<div className='menuCon'>
					<div className='leftMenu'>
						<LeftMenu />
					</div>
					<div className='rightMenu'>
						<RightMenu />
					</div>
					<Button
						className='barsMenu'
						type='primary'
						onClick={() => setToggle(true)}>
						<span className='barsBtn'></span>
					</Button>
					<Drawer
						title='Select options'
						placement='left'
						closable={false}
						onClose={() => setToggle(false)}
						visible={toggle}>
						<LeftMenu />
						<RightMenu />
					</Drawer>
				</div>
			</div>
		</nav>
	);
};

NavBar.defaultProps = defaultProps;
